export enum EnumNotificationType {
  success = "success",
  info = "info",
  warning = "warning",
  error = "error",
}
